import { Button } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './Offers.css';
import { IOfferItemProps } from './components/OfferItem';

interface IOffersProps {
  children: React.ReactElement<IOfferItemProps>[];
  pending?: boolean;
  paginationPending?: boolean;
  withShowMore?: boolean;

  onShowMore(): void;
}

export const Offers: React.FC<IOffersProps> = ({ children, pending, paginationPending, withShowMore, onShowMore }) => {
  const handleShowMore = React.useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      onShowMore();

      e.currentTarget.blur();
    },
    [onShowMore],
  );

  return (
    <div className={styles['container']}>
      <ul className={styles['list']}>{children}</ul>
      {withShowMore && (
        <div className={styles['button-container']}>
          <Button
            loading={paginationPending}
            onClick={handleShowMore}
            theme="fill_secondary"
            disabled={pending}
            fullWidth
          >
            Посмотреть еще
          </Button>
        </div>
      )}
    </div>
  );
};

Offers.displayName = 'Offers';
